import React from 'react';
import Seo from '../../components/Seo';
import { getStaticMeta } from '../../seo/pageMeta';

const RefundPolicyScreen = () => {
  const meta = getStaticMeta('refund', 'fr');

  return (
    <div className="min-h-screen bg-bg pt-28 pb-24 md:pt-32">
      <Seo title={meta.title} description={meta.description} path="/refund" />
      <div className="mx-auto max-w-page px-6">
        <article className="max-w-3xl mx-auto prose prose-invert prose-headings:text-body prose-a:text-primary prose-p:text-muted prose-li:text-muted">
          <h1>Politique de Remboursement</h1>
          <p className="text-sm !text-muted">
            Dernière mise à jour
          </p>

          <section>
            <h2>1. Introduction</h2>
            <p>
              Chez Alturion, nous souhaitons que vous soyez entièrement satisfait de votre achat. 
              Cette politique de remboursement définit les conditions dans lesquelles un remboursement peut être effectué pour nos indicateurs de trading pour NinjaTrader 8.
            </p>
          </section>

          <section>
            <h2>2. Produits numériques et droit de rétractation</h2>
            <p>
              Conformément à l'article L.221-28 du Code de la consommation, le droit de rétractation ne peut être exercé pour les contrats de fourniture d'un contenu numérique non fourni sur un support matériel dont l'exécution a commencé après accord préalable exprès du consommateur et renoncement exprès à son droit de rétractation.
            </p>
            <p>
              En validant votre commande sur notre site, vous reconnaissez expressément renoncer à votre droit de rétractation dès la mise à disposition du contenu numérique (téléchargement ou accès au produit).
            </p>
          </section>

          <section>
            <h2>3. Conditions de remboursement</h2>
            <p>
              Malgré l'absence de droit légal de rétractation pour les contenus numériques, nous pouvons, à titre commercial et dans certaines conditions, accepter un remboursement dans les cas suivants :
            </p>
            <ul>
              <li><strong className="text-body">Incompatibilité technique</strong> : Si vous rencontrez des problèmes techniques avérés et documentés avec votre version de NinjaTrader 8 qui rendent l'indicateur inutilisable, et si notre équipe de support technique n'est pas en mesure de résoudre ces problèmes dans un délai raisonnable.</li>
              <li><strong className="text-body">Erreur dans la description du produit</strong> : Si les fonctionnalités essentielles de l'indicateur diffèrent significativement de ce qui a été décrit sur notre site.</li>
              <li><strong className="text-body">Double achat accidentel</strong> : Si vous avez involontairement acheté deux fois le même indicateur.</li>
            </ul>
          </section>

          <section>
            <h2>4. Procédure de demande de remboursement</h2>
            <p>Pour demander un remboursement, veuillez suivre ces étapes :</p>
            <ol>
              <li>Contactez notre service client à support@alturionlabs.com dans les 7 jours suivant votre achat.</li>
              <li>Indiquez le motif précis de votre demande de remboursement avec le maximum de détails.</li>
              <li>Mentionnez votre numéro de commande et l'indicateur concerné.</li>
              <li>Si la demande concerne une incompatibilité technique, décrivez précisément le problème rencontré et joignez des captures d'écran si possible.</li>
            </ol>
            <p>
              Toute demande de remboursement sera examinée au cas par cas par notre équipe, qui vous contactera dans un délai de 48 heures ouvrées.
            </p>
          </section>

          <section>
            <h2>5. Délai de remboursement</h2>
            <p>
              Si votre demande de remboursement est acceptée, nous procéderons au remboursement dans un délai de 14 jours à compter de la date d'acceptation de votre demande.
            </p>
            <p>
              Le remboursement sera effectué par le même moyen de paiement que celui utilisé lors de l'achat, sauf accord spécifique entre nous.
            </p>
          </section>

          <section>
            <h2>6. Cas particuliers</h2>
            <h3>6.1 Mises à jour et nouvelles versions</h3>
            <p>
              L'achat d'un indicateur inclut généralement les mises à jour mineures (corrections de bugs, améliorations de performance). Les mises à jour majeures ajoutant de nouvelles fonctionnalités significatives peuvent faire l'objet d'un paiement supplémentaire.
            </p>
            <p>
              Aucun remboursement ne sera accordé sur la base d'une insatisfaction liée à une mise à jour ou à l'absence de certaines fonctionnalités dans les mises à jour futures.
            </p>
            <h3>6.2 Offres promotionnelles et bundles</h3>
            <p>
              Les indicateurs achetés dans le cadre d'une offre promotionnelle ou d'un bundle peuvent être soumis à des conditions de remboursement spécifiques, qui seront précisées lors de l'achat.
            </p>
          </section>

          <section>
            <h2>7. Annulation du droit d'utilisation</h2>
            <p>
              En cas de remboursement, votre droit d'utilisation de l'indicateur concerné sera automatiquement annulé. Vous vous engagez à désinstaller l'indicateur de tous vos appareils et à ne plus l'utiliser.
            </p>
          </section>

          <section>
            <h2>8. Contact</h2>
            <p>Pour toute question concernant notre politique de remboursement, veuillez nous contacter :</p>
            <ul>
              <li>Email : support@alturionlabs.com</li>
            </ul>
          </section>
        </article>
      </div>
    </div>
  );
};

export default RefundPolicyScreen;
